import { useEffect, useState, useRef } from 'react';
import { time as TIME } from '../utils/time';

export const useTime = ({ interval = 1 }) => {
  const [time, setTime] = useState(TIME());
  const timer = useRef(0);

  useEffect(() => {
    if (timer.current) {
      clearInterval(timer.current);
    }

    timer.current = setInterval(() => {
      setTime(TIME());
    }, 1000 * interval);

    return () => {
      clearInterval(timer.current);
    };
  }, []);

  return time;
};

export default useTime;
